module.exports = __webpack_public_path__ + "img/city-center-blue.9561b209.svg";